import { isEmpty } from "lodash";

import { SET_LOADING_STATE } from "store/constants";

const validator = (value) => !isEmpty(value) && /[a-zA-Z]/g.test(value);

const isNumeric = (str) => /^\d+$/.test(str);

const isAdmin = (username) => username === "admin@remote-jobs.global";

const parseJobType = (type) =>
  type === "full-time" ? "Full Time" : "Contract";

const parseCompanySize = (size) => {
  switch (size) {
    case "small":
      return "1-10 employess";
    case "medium":
      return "10-100 employees";
    case "large":
      return "100-500 employees";
    case "xLarge":
      return "500-1000 employees";
    case "xxLarge":
      return "1000+ employees";
    default:
      return "1-10 employess";
  }
};

export const updateLoginState = (dispatch, key, isLoading) => {
  dispatch({
    type: SET_LOADING_STATE,
    payload: { [key]: isLoading },
  });
};

export default {
  validator,
  isNumeric,
  isAdmin,
  parseJobType,
  parseCompanySize,
  updateLoginState,
};
